export default __webpack_public_path__ + "478b56c.png";